import { render } from "./pb-formparticipants.vue?vue&type=template&id=9e2d55b6"
import script from "./pb-formparticipants.vue?vue&type=script&lang=js"
export * from "./pb-formparticipants.vue?vue&type=script&lang=js"

import "./pb-formparticipants.vue?vue&type=style&index=0&id=9e2d55b6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__